import type { ProductGroupInterface } from '~/src/models/types/knowledge-base.types';

export const splitArray = (array: Array<ProductGroupInterface>, size: number) => {
    const slicedArray = [];

    for (let i = 0; i < array.length; i += size) {
        slicedArray.push(array.slice(i, i + size));
    }

    return slicedArray;
};

export const getDesktopDataProducts = (array: Array<ProductGroupInterface>) => {
    const firstColumnArray = [];
    const secondColumnArray = [];
    const thirdColumnArray = [];

    let firstCurrentIndex = 0;
    let secondCurrentIndex = 1;
    let thirdCurrentIndex = 2;
    const step = 3;

    for (let i = 0; i < array.length; i++) {
        if (firstCurrentIndex === i) {
            firstColumnArray.push(array[i]);
            firstCurrentIndex += step;
        } else if (secondCurrentIndex === i) {
            secondColumnArray.push(array[i]);
            secondCurrentIndex += step;
        } else if (thirdCurrentIndex === i) {
            thirdColumnArray.push(array[i]);
            thirdCurrentIndex += step;
        }
    }

    return [firstColumnArray, secondColumnArray, thirdColumnArray];
};

export const getTabletDataProducts = (array: Array<ProductGroupInterface>) => {
    const firstColumnArray = [];
    const secondColumnArray = [];

    for (let i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
            secondColumnArray.push(array[i]);
        } else {
            firstColumnArray.push(array[i]);
        }
    }

    return [firstColumnArray, secondColumnArray];
};
